import { render } from "./CostList.vue?vue&type=template&id=81c7f28a&scoped=true"
import script from "./CostList.vue?vue&type=script&lang=js"
export * from "./CostList.vue?vue&type=script&lang=js"

import "./CostList.vue?vue&type=style&index=0&id=81c7f28a&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-81c7f28a"

export default script